/**
 *
 * @description: 兴证全球
 *
 */
import { isBuild } from '@/apis/host';
import { isThirdPartyMode, BridgeBase } from './bridge_utils';

const brmChannel = 'xzqq';
const comein_channel = isBuild ? 'ef3a3f91-0b4d-43eb-99d2-dbfb9ea34d79' : '7ff2b851-457c-4f98-ab15-d5ed709441ab';

export const isThirdParty = isThirdPartyMode({ brmChannel, comein_channel });

if (isThirdParty) window.comeinChannel = 'xzqq';

// 兴证全球Bridge类 - 继承基类，showMenu = true
class Bridge extends BridgeBase {
  constructor() {
    super(brmChannel, true); // showMenu = true
  }
}

// 导出实例作为默认导出（用于直接使用）
export default new Bridge();

// 同时导出类（用于 bridge.js 的原型链合并）
export { Bridge };
